var map = {
	"./C1 copy.jpg": 5733,
	"./C1.jpg": 4073,
	"./C2 copy.jpg": 3381,
	"./C2.jpg": 157,
	"./C3 copy.jpg": 7303,
	"./C3.jpg": 5171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5950;